<ng-template #dropdownButtonTemplate>
  <ng-container *ngIf="isActive; else defaultButtonText">
    <ng-container *ngIf="roomCountIsSameForMinAndMax; else defaultActiveText">
      {{ appliedFilter.min.text }} {{ 'filters.roomCount.label' | i18n }}
    </ng-container>
    <ng-template #defaultActiveText>
      {{ appliedFilter.min.text }} - {{ appliedFilter.max.text }}
      {{ 'filters.roomCount.label' | i18n }}
    </ng-template>
  </ng-container>
  <ng-template #defaultButtonText>
    {{ 'filters.roomCount.label' | i18n }}
  </ng-template>
</ng-template>

<ng-template #dropdownContentTemplate>
  <lib-room-count-filter (update)="select($event)"></lib-room-count-filter>
</ng-template>

<ng-template #applyButtonTemplate let-close="close">
  <button class="filter-apply-button" (click)="applyChanges(); close()">
    {{ 'common.apply' | i18n }}
  </button>
</ng-template>

<app-filter-dropdown
  [preferredWidth]="271"
  [dropdownButtonTemplate]="dropdownButtonTemplate"
  [dropdownContentTemplate]="dropdownContentTemplate"
  [applyButtonTemplate]="applyButtonTemplate"
  [hasValue]="isActive"
  (clear)="reset()"
>
</app-filter-dropdown>
